// src/utils/constants.js — centralised app links & site constants
export const APP_LINKS = {
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie',
  appStore:
    'https://apps.apple.com/us/app/trend-genie-ai-market-analysis/id6769978798',
};

export const SITE_URL = 'https://www.trendgenie.io';
export const SOCIAL_IMAGE = 'https://www.trendgenie.io/social-share-image.png';
export const TWITTER_HANDLE = '@trendgenie_ai';
